module.exports = __webpack_public_path__ + "static/media/01B.8c84f4b8.png";